import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { PreworkSummaryListDetailchild } from "../../types/PreworksummaryModel";
import { GetInstruction } from "../../api/preworkSummaryApi/preworkSummaryApi";
import LocalStorageUtil from "../../utils/localStorage";
import { appSettings } from "../../config/appSetting";

interface NoteesProp {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  selectedData: any;
  gridType: string;
  screen: string;
}
const Notes: React.FC<NoteesProp> = ({
  isOpen,
  onClose,
  title,
  selectedData,
  gridType,
  screen,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [notesData, setNotesData] = useState<any>(null);
  const [_confirmDialogOpen, set_ConfirmDialogOpen] = useState<boolean>(false);// NOSONAR

  //Close the dialog box
  const handleCloseClick = () => {
    set_ConfirmDialogOpen(true);


  };

  useEffect(() => {
    if (isOpen) {
      getNotesData();
    }
  }, [isOpen]);

  const getNotesData = async () => {   
    setLoading(true);
    try {
      let param: PreworkSummaryListDetailchild;
      if (screen.toLowerCase() === "preworkdetail") {
        param = {
          ChildFileDocumentStreamID:
            gridType.toLowerCase() === "parent"
              ? null
              : selectedData.childFileDocumentStreamID,
          Timezone: appSettings.timezone,
          ParentDocumentID:
            gridType.toLowerCase() === "parent"
              ? selectedData.DocumentStreamID ?? selectedData.childDocumentID
              : null,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        };
      } else {
        param = {
          ChildFileDocumentStreamID: selectedData.DocumentStreamID,
          Timezone: appSettings.timezone,
          ParentDocumentID: null,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        };
      }      
      const response = await GetInstruction(param);
      if (response !== null) {
        setNotesData(response);
        console.log(response);
      }
    } catch (error) {
      console.error("Error in getNotesData", error);
    } finally {
      setLoading(false);
    }
  };

  // Removed parseNotesData function as it's no longer needed.
  // This function was previously parsing HTML notes data into structured format.

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCloseClick}
        maxWidth="xs"
        PaperProps={{
          style: {
            height: "50%",
            width: "30%",
          },
        }}
      >
        <DialogTitle style={{ backgroundColor: "var(--primary-color)",
                  color: "var(--aggrid-text-color)",
                  fontSize: "16px", 
                  fontWeight: 500, 
                  padding: "12px 16px", 
                  display: "flex",
                  alignItems: "center", }}>
          <div
            className="col-sm-12"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <div
              className="col-sm-11"
              style={{
                display: "flex",
                alignItems: "left",
                gap: "10px",
                color: "var(--aggrid-text-color)",
              }}
            >
              {title}
            </div>
            <div
              className="col-sm-1"
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "right",
              }}
            >
              {" "}
              <Tooltip title="Close">
                <IconButton
                  onClick={onClose}
                  style={{
                    cursor: "pointer",
                    alignItems: "flex-end",
                    color: "var(--aggrid-text-color)",
                    width: "20px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div className="row">
              <div className="col-sm-12" style={{ marginTop: "10px" }}>
                <div>
                  {" "}
                  {notesData &&
                    <p><div dangerouslySetInnerHTML={{ __html: notesData }} /></p>}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default Notes;
